// extracted by mini-css-extract-plugin
module.exports = {"topTitle":"styles_topTitle__Aufkz"};